import React from "react";
import { Link } from "react-router-dom";
import { FadeUp, RevealLines } from "@/components/motion/Reveal";
import { Heart, Store, Users, ArrowRight } from "lucide-react";

export default function About() {
  return (
    <div className="pt-[72px]">
      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-24 grain relative">
        <p className="font-display uppercase tracking-[0.25em] text-primary text-sm font-bold mb-6">
          Our story
        </p>
        <h1 className="font-display font-extrabold text-5xl sm:text-7xl tracking-tighter leading-[0.95] max-w-4xl">
          <RevealLines lines={["We built NearbyDeals", "for the shops that", "make a street feel"]} />
          <span className="text-primary italic font-serif-editorial"> like home.</span>
        </h1>
        <FadeUp delay={0.4}>
          <p className="mt-8 text-xl text-muted-foreground max-w-2xl leading-relaxed">
            Big platforms flatten the local into the global. We&rsquo;re doing the opposite &mdash; putting the
            bakery, the barber and the bookshop back on the map, and giving the people who run them
            the tools to be found, followed and supported.
          </p>
        </FadeUp>
      </section>

      <section className="bg-secondary/60 py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 grid md:grid-cols-3 gap-6">
          {[
            { icon: Store, title: "1,200+ shops", text: "Independent businesses discoverable on NearbyDeals today." },
            { icon: Users, title: "40,000 locals", text: "Shoppers claiming offers and supporting their neighbourhood." },
            { icon: Heart, title: "100% local", text: "Every rupee spent stays in the community that earned it." },
          ].map((s, i) => {
            const Icon = s.icon;
            return (
              <FadeUp key={i} delay={i * 0.1}>
                <div className="bg-card rounded-3xl border border-border p-8 h-full">
                  <span className="grid place-items-center w-12 h-12 rounded-2xl bg-primary/10 text-primary mb-6">
                    <Icon className="w-6 h-6" />
                  </span>
                  <p className="font-display font-extrabold text-3xl tracking-tight">{s.title}</p>
                  <p className="text-muted-foreground mt-2">{s.text}</p>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 sm:px-8 py-24 text-center">
        <FadeUp>
          <h2 className="font-display font-bold text-4xl tracking-tight mb-6">
            Join the neighbourhood.
          </h2>
          <Link
            to="/auth?mode=register"
            className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground font-semibold px-8 py-4 hover:bg-primary/90 transition-colors"
          >
            Get started free <ArrowRight className="w-4 h-4" />
          </Link>
        </FadeUp>
      </section>
    </div>
  );
}
